module.exports = __webpack_public_path__ + "img/zphd_zz_s2.62d2113c.png";